export default {"src":"/assets/_next/static/media/es.6b0af0e0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};